import { useEffect, useId, useRef, useState, type ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  align?: "start" | "end";
};

export function InfoTip({ title, children, align = "start" }: Props) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLSpanElement | null>(null);
  const labelId = useId();

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (root.current && !root.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <span ref={root} className={`mf-info${align === "end" ? " end" : ""}`}>
      <button
        type="button"
        className={`mf-info-btn${open ? " on" : ""}`}
        aria-expanded={open}
        aria-controls={open ? labelId : undefined}
        aria-label={`About ${title}`}
        onClick={() => setOpen((v) => !v)}
      >
        i
      </button>
      {open ? (
        <div className="mf-info-pop" id={labelId} role="dialog" aria-label={title}>
          <strong>{title}</strong>
          <div className="mf-info-body">{children}</div>
          <button type="button" className="mf-btn ghost" onClick={() => setOpen(false)}>
            Close
          </button>
        </div>
      ) : null}
    </span>
  );
}
